// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","toggle-button":"Header_toggle-button__+cvta","dark-mode":"Header_dark-mode__-bcs2"};